export const formatWithComma = (v) => {
  if (v === null || v === undefined) return "";
  const s = String(v).replace(/[^0-9]/g, "");
  if (!s) return "";
  return s.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

